module.exports = __webpack_public_path__ + "img/grazi_logo_small.80b38921.png";